import styled from "styled-components"
import { CSVLink } from "react-csv"
import { styles } from "../../button/styles"

export const StyledCSVLink = styled(CSVLink)`
  ${styles}
`
